
import React from 'react';
import BlogPostCard from './BlogPostCard';
import { BlogPost } from '@/services/blogService';

interface BlogPostGridProps {
  posts: BlogPost[];
  isLoading: boolean;
  onCategoryClick: (category: string) => void;
  onTagClick: (tag: string) => void;
  selectedTag: string | null;
}

const BlogPostGrid: React.FC<BlogPostGridProps> = ({ 
  posts, 
  isLoading, 
  onCategoryClick, 
  onTagClick, 
  selectedTag 
}) => {
  if (posts.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-xl text-muted-foreground">No articles found matching your criteria.</p>
        <p className="mt-2">Try adjusting your search or filter options.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {posts.map((post, index) => (
        <BlogPostCard
          key={post.id}
          post={post}
          index={index}
          isLoading={isLoading}
          onCategoryClick={onCategoryClick}
          onTagClick={onTagClick}
          selectedTag={selectedTag}
        />
      ))}
    </div>
  );
};

export default BlogPostGrid;
